import { ILoanDetail } from "../types/g-l-calculatortypes.types";
import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

type ILoanDetailRequest = {
  mobileNo: string;
  customerId: string;
  prodCategory: string;
};

export const getGoldLoanDetails = async (
  data: ILoanDetailRequest
): Promise<IResponse<Partial<ILoanDetail>[]>> => {
  try {
    const response: IResponse<Partial<ILoanDetail>[]> = await encryptedRequest({
      method: "POST",
      url: `${API_PATHS.goldLoanDetails}`,
      data,
    });

    return response;
  } catch (err) {
    console.error(err);
    return {} as IResponse<Partial<ILoanDetail>[]>;
  }
};
